<template>
    <div class="water-drop-container">
        <div
            v-for="(drop, index) in waterDrops"
            :key="`drop-${index}`"
            class="water-drop"
            :style="{
                left: drop.left + '%',
                animationDelay: drop.delay + 's',
                animationDuration: drop.duration + 's',
            }"
        ></div>
    </div>
</template>

<script>
export default {
    name: "WaterDropAnimation",
    data() {
        return {
            waterDrops: [],
        };
    },
    mounted() {
        this.generateWaterDrops();
    },
    methods: {
        generateWaterDrops() {
            this.waterDrops = [];
            for (let i = 0; i < 8; i++) {
                this.waterDrops.push({
                    left: Math.random() * 100,
                    delay: Math.random() * 2,
                    duration: 1.5 + Math.random() * 1,
                });
            }
        },
    },
};
</script>

<style scoped>
.water-drop-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
}

.water-drop {
    position: absolute;
    width: 4px;
    height: 4px;
    background: linear-gradient(45deg, #b3e5fc, #81d4fa);
    border-radius: 50%;
    opacity: 0.7;
    animation: waterDropFall linear infinite;
}

.water-drop::before {
    content: "";
    position: absolute;
    top: -2px;
    left: 1px;
    width: 2px;
    height: 2px;
    background: #b3e5fc;
    border-radius: 50%;
    opacity: 0.5;
}

@keyframes waterDropFall {
    0% {
        transform: translateY(-10px) scale(0.8);
        opacity: 0;
    }
    10% {
        opacity: 0.7;
    }
    90% {
        opacity: 0.7;
    }
    100% {
        transform: translateY(100px) scale(1.2);
        opacity: 0;
    }
}
</style>
